import { http } from './http';

// Маркеры в контексте CHPO
export async function listMapMarkers(params = {}) {
  const { data } = await http.get('map/markers/', { params });
  return data;
}

export async function createMapMarker(payload) {
  const { data } = await http.post('map/markers/', payload);
  return data;
}

export async function updateMapMarker(id, payload) {
  const { data } = await http.patch(`map/markers/${id}/`, payload);
  return data;
}

export async function deleteMapMarker(id) {
  const { data } = await http.delete(`map/markers/${id}/`);
  return data;
}

// Глобальные маркеры (без префикса ), согласно требованию "map/markers/"
export async function listAllMapMarkers(params = {}) {
  const { data } = await http.get('map/markers/', { params });
  return data;
}

